export const getAnalytics = (state) => state.analytics;
export const getAnalyticsOverview = (state) => state.analytics.overview;
export const getAnalyticsFilter = (state) => state.analytics.filter;
export const getAnalyticsDatePeriod = (state) => state.analytics.datePeriod;
